@use '@ingka/variables/style.scss' as *;

.loginPageHeader {
  margin-block-end: $space-150;
}

.loginPageDescription {
  margin-block-end: $space-50;
}

.inlineMessage {
  margin-block: $space-150;
}

.loginEmail {
  margin-block-end: $space-150;
}

.loginPassword {
  margin-block-end: $space-100;
}

.resetPasswordLink {
  display: inline-block;
  width: auto;
  color: $colour-text-and-icon-2;

  &:focus {
    box-shadow:
      0 0 0 0.25rem $colour-neutral-1,
      0 0 0 0.375rem $colour-text-and-icon-1;
    outline: none;
    transition-duration: 200ms;
    transition-property: box-shadow;
    transition-timing-function: ease-out;
    z-index: 1;
  }
}

.fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.loginButton {
  margin-block-start: $space-300;
  margin-block-end: $space-100;
}

.divider {
  display: flex;
  align-items: center;
  width: 100%;
  gap: $space-100;

  margin-block: $space-50 $space-150;
  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: $thickness-thin;
    background-color: $colour-neutral-4;
  }
}

.turnstileContainer {
  margin-block-end: -$space-200;
}

.turnstile {
  margin-block-start: $space-100;
}

.turnstileBoxError {
  height: 67px !important; // Magic number from turnstile to be able to add border to the box
  border: 1px solid $colour-semantic-negative;
}

.turnstileFormError {
  display: flex;
  align-items: center;
  color: $colour-semantic-negative;
  margin-block-start: $space-25;
  font-size: $font-size-50;
}

.noticeRedSmallIcon {
  margin-inline-end: $space-25;
}
